/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

//date picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//img
import square_plus from "../../../../assets/icons/square-plus-solid.svg";

//Childs
import { convertLocalToUTCDate } from "../../../../utils";
import constants from "../../../../utils/constants";
import AddBeneficiary from "./AddBeneficiary";

// utils
import areObjectsEqual from "../../../../utils/areObjectsEqual";

import Dropdown from "../../../Common/Dropdown";
import { useGlobal } from "../../../../context/GlobalContextProvider";
import { useWallet } from "../../../../context/WalletContextProvider";

const Form = ({ formData, handleSubmit, onDiscard, selector, typeCheck, draftRestoreData }) => {
  const { apiConstants } = useWallet();
  const { setSpinner, setArtPack, campaign } = useGlobal();
  const [form, setForm] = useState(formData);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [noLimitNft, setNoLimitNft] = useState(formData.ct_no_limit_nft);
  const [datesRange, setDatesRange] = useState(false);

  const changesFound = !areObjectsEqual(formData, form);
  const isDraftRestored = draftRestoreData !== null;
  const hasValidChanges = changesFound || isDraftRestored;

  //Prev Data
  const [beneficiary, setBeneficiary] = useState([]);
  const [artist, setArtist] = useState([]);
  const [artPackList, setArtPackList] = useState([]);

  const [showBeneficiaryPopup, setOpenBeneficiary] = useState(false);

  //Status errors
  const [errorCampaignName, setErrorCampaignName] = useState(false);
  const [errorBeneficiary, setErrorBeneficiary] = useState(false);
  const [errorArtPack, setErrorArtPack] = useState(false);
  const [errorStartsOn, setErrorStartsOn] = useState(false);
  const [errorEndsOn, setErrorEndsOn] = useState(false);
  const [errorMaxCount, setErrorMaxCount] = useState(false);
  const [errorMaxCountMin, setErrorMaxCountMin] = useState(false);
  const [errorCheckName, setErrorCheckName] = useState(false);

  const navigate = useNavigate();

  // check if the name exist in another wallets
  const checkUnique = async (name, id) => {
    const encodedName = encodeURIComponent(name);
    const res = await fetch(`/api/sponsor/checkname/${encodedName}/${id}/campaign`);

    // If the response is successful, populate the form data
    if (res.status === 200) {
      const data = await res.json();
      const { checkStatus } = data;
      setErrorCheckName(checkStatus);
      return checkStatus;
    }
  };

  const loadArtPack = async (artistwallet) => {
    setArtPackList([]); //reset ap list
    setSpinner(true);
    const res = await fetch(
      `/api/artist/${artistwallet}/artpack/available/${formData.art_pack_id}`
    );
    if (res.status === 200) {
      const json = await res.json();
      const data = json
        .filter((i) => i.sc_id > 0)
        .map((el) => {
          return {
            art_pack_id: el.art_pack_id,
            art_pack_name: el.art_pack_name,
            artist_id: el.artist_id,
            copyright_notice_url: el.copyright_notice_url,
            preview_url: el.preview_url,
            available_for_campaigns: el.available_for_campaigns,
            min_artist_percentage: el.min_artist_percentage
          };
        });
      setArtPackList(data ? data : []);

      //setSpinner(false)
    }

    setSpinner(false);
  };

  useEffect(() => {
    //get all beneficiarys
    const getBeneficiaryList = async (url) => {
      const res = await fetch(`/api/beneficiary`);
      const json = await res.json();

      const data = json.map((el) => {
        return {
          beneficiary_id: el.beneficiary_id,
          beneficiary_name: el.beneficiary_name,
          beneficiary_address: el.beneficiary_address,
        };
      });
      setBeneficiary(data);
    };
    getBeneficiaryList();
    //get all art packs
    const getArtistList = async () => {
      const res = await fetch(`/api/artist`);
      if (res.status === 200) {
        const json = await res.json();
        const data = json.map((el) => {
          return {
            id: el.artist_address,
            name: `${el.artist_name} - ${el.artist_address.slice(
              0,
              6
            )}...${el.artist_address.slice(el.artist_address.length - 4)}`,
            artist_id: el.artist_id,
          };
        });
        setArtist(data);
      }
    };
    getArtistList();
    if (form.starts_on) setStartDate(new Date(form.starts_on));
    if (form.ends_on) setEndDate(new Date(form.ends_on));
  }, []);

  // Handle draft restore data from preview
  useEffect(() => {
    if (draftRestoreData) {
      if (draftRestoreData.startDate) {
        setStartDate(new Date(draftRestoreData.startDate));
      }
      if (draftRestoreData.endDate) {
        setEndDate(new Date(draftRestoreData.endDate));
      }
      if (draftRestoreData.noLimitNft !== undefined) {
        setNoLimitNft(draftRestoreData.noLimitNft);
      }
    }
  }, [draftRestoreData]);

  useEffect(() => {
    loadArtPack(selector.artist_address);
  }, [selector]);

  // Set artpack in global context when form loads with existing artpack
  useEffect(() => {
    if ((formData.art_pack_id || form.art_pack_id) && artPackList.length > 0) {
      const artPackId = formData.art_pack_id || form.art_pack_id;
      const selectedArtPack = artPackList.find(
        (item) => Number(item.art_pack_id) === Number(artPackId)
      );
      if (selectedArtPack) {
        setArtPack(selectedArtPack);
        sessionStorage.setItem(constants.ART_PACK_IDENTIFIER, selectedArtPack.art_pack_id);
      }
    }
  }, [formData.art_pack_id, form.art_pack_id, artPackList]);

  const handleChange = (e) => {
    if (e.target.name === "dates_locked") {
      setForm({
        ...form,
        [e.target.name]: e.target.checked,
      });
    } else if (e.target.name === "ct_no_limit_nft") {
      setForm({
        ...form,
        [e.target.name]: e.target.checked,
      });
      setNoLimitNft(e.target.checked);
      setForm({ ...form, ct_no_limit_nft: e.target.checked });
    } else if (
      e.target.name === "campaign_name" ||
      e.target.name === "beneficiary_id" ||
      e.target.name === "art_pack_id"
    ) {
      setForm({
        ...form,
        [e.target.name]: e.target.value,
      });
    } else {
      let newValue;

      if (e.target.name === "max_count") {
        newValue = Math.max(0, Math.min(500, Number(e.target.value)));
      } else {
        newValue = Math.max(0, Math.min(100, Number(e.target.value)));
      }
      setForm({
        ...form,
        [e.target.name]: newValue,
      });
    }
  };

  const handleDropdownChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const handleArtPackDropdownChange = (value) => {
    setForm({ ...form, art_pack_id: value?.art_pack_id });
    setArtPack(value);
    if (value?.art_pack_id) {
      sessionStorage.setItem(constants.ART_PACK_IDENTIFIER, value.art_pack_id);
    }
  };

  const handleReset = () => {
    setErrorCampaignName(false);
    setErrorBeneficiary(false);
    setErrorArtPack(false);
    setErrorStartsOn(false);
    setErrorEndsOn(false);
  };

  //errors control
  const handleClick = async (e) => {
    handleReset();

    let isNameUnique;

    //error campaign name
    if (!form.campaign_name) setErrorCampaignName(true);
    //error beneficiary
    if (!form.beneficiary_id) setErrorBeneficiary(true);
    //error art pack
    if (!form.art_pack_id) setErrorArtPack(true);
    //error starts on
    if (!form.starts_on) setErrorStartsOn(true);

    if (!form.ends_on) setErrorEndsOn(true);

    //error max count
    if (form.max_count == null) setErrorMaxCount(true);
    //error max count min 1
    if (form.max_count <= 0) setErrorMaxCountMin(true);

    if (typeCheck === "createItem") {
      isNameUnique = await checkUnique(form.campaign_name, 0);
    } else if (typeCheck === "updateItem") {
      isNameUnique = await checkUnique(form.campaign_name, form.campaign_id);
    }

    setErrorCheckName(isNameUnique);

    if (
      form.campaign_name &&
      form.beneficiary_id &&
      form.art_pack_id &&
      form.starts_on &&
      form.ends_on &&
      !datesRange &&
      form.beneficiary_distro_min != null &&
      form.beneficiary_distro_max != null &&
      form.sponsor_distro_min != null &&
      form.sponsor_distro_max != null &&
      form.artist_distro_min != null &&
      form.artist_distro_max != null &&
      form.seller_distro_min != null &&
      form.seller_distro_max != null &&
      form.max_count > 0 &&
      !isNameUnique
    ) {
      //send the new data to te father components
      handleSubmit(form, artPackDetails);
    }
  };

  const renderBeneficiaryPopup = () => {
    return (
      <AddBeneficiary
        setOpenBeneficiary={setOpenBeneficiary}
        showBeneficiaryPopup={showBeneficiaryPopup}
        setBeneficiary={setBeneficiary}
      />
    );
  };

  const showArtistName = () => {
    const matchedArtist = artist.filter((eachArtist) =>
      artPackList.find(
        (eachArtPack) => Number(eachArtPack.artist_id) === eachArtist.artist_id
      )
    );
    if (matchedArtist.length !== 0) {
      return matchedArtist[0].name;
    } else return "Choose an option";
  };

  const navigateToPreview = () => {
    const artPackId = form.art_pack_id || formData.art_pack_id;

    if (artPackId) {
      sessionStorage.setItem(constants.ART_PACK_IDENTIFIER, artPackId);

      // Also ensure the artpack object is set in global context
      const selectedArtPack = artPackList.find(
        (item) => Number(item.art_pack_id) === Number(artPackId)
      );
      if (selectedArtPack) {
        setArtPack(selectedArtPack);
      } else {
      }
    } else {
    }
    // Sponsor campaign form preview - show only mint page without header/footer
    sessionStorage.setItem('previewSource', 'sponsor');
    sessionStorage.setItem('previewContext', 'campaign-form');
    // Store campaign ID for returning to the specific campaign form, or indicate creating mode
    if (form.campaign_id || formData.campaign_id) {
      sessionStorage.setItem('previewCampaignId', form.campaign_id || formData.campaign_id);
    } else {
      // Creating new campaign - store form state and additional data
      const draftData = {
        form: form,
        startDate: startDate,
        endDate: endDate,
        noLimitNft: noLimitNft,
        selectors: selector
      };
      sessionStorage.setItem('previewCreateMode', 'true');
      sessionStorage.setItem('previewFormDraft', JSON.stringify(draftData));
    }
    navigate("/preview-home/mint")
  }

  const artPackDetails = useMemo(() => artPackList.find(
    (item) => Number(item.art_pack_id) === (form.art_pack_id || formData.art_pack_id)
  ), [artPackList, form.art_pack_id, formData.art_pack_id]);

  return (
    <>
      <div className="row">
        {/* campaign name */}
        <div className="mt-4">
          <div className="form-labels">
            Campaign Name{" "}
          </div>

          <input
            type="text"
            name="campaign_name"
            id="campaign_name"
            placeholder=""
            onChange={handleChange}
            value={form.campaign_name}
            className="form-control inputs"
            maxLength={100}
          />
          {errorCampaignName ? (
            <span id="errorCampaignName" className="form-text text-danger">
              Name is required
            </span>
          ) : (
            <span></span>
          )}

          {errorCheckName && (
            <span className="form-text text-danger">
              This Campaing Name already exists, please use a different one.
            </span>
          )}
        </div>

        {/* beneficiary */}
        <div className="mt-5">
          <div className="form-labels">
            <div className="label-combo">
              Beneficiary
              <img
                src={square_plus}
                className="square-plus"
                onClick={() => {
                  setOpenBeneficiary(true);
                }}
                alt="img"
              />
            </div>
          </div>
          {beneficiary.length !== 0 && (
            <Dropdown
              category="campaign"
              categorySubType="beneficiary"
              dropdownList={beneficiary}
              dropdownHeader={
                beneficiary.find(
                  (item) =>
                    Number(item.beneficiary_id) === formData.beneficiary_id
                )?.beneficiary_name || "Select a Beneficiary"
              }
              handleChange={handleDropdownChange}
            />
          )}
          {beneficiary.length === 0 && (
            <Dropdown
              category="campaign"
              categorySubType="beneficiary"
              dropdownList={beneficiary}
              dropdownHeader={"Select a Beneficiary"}
              handleChange={handleDropdownChange}
            />
          )}
          {errorBeneficiary ? (
            <span id="errorBeneficiary" className="form-text text-danger">
              Beneficiary is required
            </span>
          ) : (
            <span></span>
          )}
        </div>

        {/* Artist */}
        <div className="mt-5">
          <div className="form-labels">
            Artist
          </div>
          {artist.length !== 0 && artPackList.length !== 0 && (
            <Dropdown
              category="campaign"
              categorySubType="artist"
              dropdownList={artist}
              dropdownHeader={showArtistName}
              handleChange={loadArtPack}
            />
          )}
          {artist.length !== 0 && artPackList.length === 0 && (
            <Dropdown
              category="campaign"
              categorySubType="artist"
              dropdownList={artist}
              dropdownHeader="Select an Artist"
              handleChange={loadArtPack}
            />
          )}
        </div>
        {/* Art pack */}
        <div className="mt-5 col-sm-12 d-flex gap-4 align-items-start">
          <div className="col-sm-9">
            <div className="form-labels">
              Art Pack
            </div>
            {artPackList.length !== 0 && (
              <Dropdown
                category="campaign"
                categorySubType="artPack"
                dropdownList={artPackList}
                dropdownHeader={
                  artPackDetails?.art_pack_name || "Select an ArtPack"
                }
                handleChange={handleArtPackDropdownChange}
              />
            )}
            {artPackList.length === 0 && (
              <Dropdown
                category="campaign"
                categorySubType="artPack"
                dropdownList={artPackList}
                dropdownHeader="Select an ArtPack"
                handleChange={handleArtPackDropdownChange}
              />
            )}
            {errorArtPack && (
              <span id="errorArtPack" className="form-text text-danger">
                Art pack is required
              </span>
            )}
            {artPackList.length > 0 && artPackDetails && (
              <span id="errorArtPack" className="form-text text-danger">Artist Minimum Percentage : {artPackDetails?.min_artist_percentage} + {apiConstants.reddevcut} (reddev) = {artPackDetails?.min_artist_percentage + apiConstants.reddevcut}%</span>
            )}
          </div>
          <div className="col-sm-3">

            <button
              className={`btn bg-orange custom-preview-campaing mt-5 form-btn d-flex align-items-center justify-content-center ${!form.art_pack_id ? "disabled" : ""
                }`}
              onClick={navigateToPreview}
            >
              Preview
            </button>
          </div>
        </div>

        {/* Starts on */}
        <div className="mt-5 col-sm-6">
          <div className="form-labels">
            Starts On
          </div>

          <DatePicker
            className="form-control inputs"
            selected={startDate}
            id="starts_on"
            dateFormat="yyyy/MM/dd"
            minDate={new Date()}
            onChange={(date) => {
              if (form.ends_on) {
                if (
                  convertLocalToUTCDate(date) <
                  convertLocalToUTCDate(form.ends_on)
                ) {
                  setDatesRange(false);
                } else {
                  setDatesRange(true);
                }
              }
              setForm({ ...form, starts_on: convertLocalToUTCDate(date) });
              setStartDate(date);
            }}
          />

          {errorStartsOn ? (
            <span id="errorStartsOn" className="form-text text-danger">
              Starts on is required
            </span>
          ) : (
            <span></span>
          )}
          {datesRange ? (
            <span id="errorDatesRange" className="form-text text-danger">
              Ends On must be superior to Starts On
            </span>
          ) : (
            <span></span>
          )}
        </div>

        {/* Ends on */}
        <div className="mt-5 col-sm-6">
          <div className="form-labels">
            Ends On
          </div>

          <DatePicker
            className="form-control inputs"
            selected={endDate ? endDate : false}
            id="ends_on"
            dateFormat="yyyy/MM/dd"
            minDate={
              startDate
                ? new Date(startDate.getTime() + 24 * 60 * 60 * 1000)
                : new Date()
            }
            maxDate={
              startDate
                ? new Date(startDate.getTime() + 90 * 24 * 60 * 60 * 1000)
                : null
            }
            onChange={(date) => {
              if (form.starts_on) {
                if (
                  convertLocalToUTCDate(date) >
                  convertLocalToUTCDate(form.starts_on)
                ) {
                  setDatesRange(false);
                } else {
                  setDatesRange(true);
                }
              }
              setForm({ ...form, ends_on: convertLocalToUTCDate(date) });
              setEndDate(date);
            }}
          />

          {errorEndsOn ? (
            <span id="errorEndsOn" className="form-text text-danger">
              Ends on is required
            </span>
          ) : (
            <span></span>
          )}
        </div>

        {/* Data locked */}
        <div className="mt-3 col-sm-6">
          <div className="form-check">
            <input
              className="form-check-input inputs"
              type="checkbox"
              value=""
              id="dates_locked"
              name="dates_locked"
              checked={form.dates_locked ? true : false}
              onChange={handleChange}
            />
            <div
              className="form-check-label form-labels"
            >
              &nbsp;Dates locked
            </div>
          </div>
        </div>

        {/* not expire */}
        <div className="mt-4 col-sm-6">

        </div>

        {/* Maximum Collection Size */}
        <div className="mt-5 col-sm-6">
          <div className="form-labels">
            Maximum number of NFTs
          </div>

          <input
            type="number"
            name="max_count"
            id="max_count"
            min={1}
            onChange={handleChange}
            value={form.max_count}
            className={`form-control inputs ${errorMaxCount ? "border-danger" : ""
              }`}
            disabled={noLimitNft}
            placeholder={noLimitNft ? "Unlimited" : ""}
          />
          {errorMaxCount ? (
            <span id="errorMaxCount" className="form-text text-danger">
              Maximum number of NFTs is required
            </span>
          ) : (
            <span></span>
          )}
          {errorMaxCountMin ? (
            <span id="errorMaxCount" className="form-text text-danger">
              Indicate at least 1 NFT
            </span>
          ) : (
            <span></span>
          )}

          {/* not limit nft */}
          <div className="mt-3 col-sm-12">
            <div className="form-check">
              <input
                className="form-check-input inputs"
                type="checkbox"
                id="ct_no_limit_nft"
                name="ct_no_limit_nft"
                checked={noLimitNft}
                onChange={handleChange}
              />

              <div
                className="form-check-label form-labels"
              >
                &nbsp;No limit NFT
              </div>
            </div>
          </div>
        </div>

        <div className="pt-5">
          <div className="btn btn-secondary form-btn me-4" onClick={onDiscard}>
            Discard 
          </div>
          <input
            type="submit"
            value="Save Changes"
            className="btn bg-orange form-btn"
            onClick={handleClick}
            disabled={campaign?.sc_id > 0 || (!hasValidChanges && !campaign?.sc_id)}
          />
        </div>
      </div>
      {renderBeneficiaryPopup()}
    </>
  );
};

export default Form;
